<template>
    <li class="align-items-lg-center align-items-start d-flex flex-md-nowrap flex-wrap justify-content-between text-center">
        <EventMetadata :event="event" />
        <div class="d-flex flex-lg-fill flex-wrap flex-md-nowrap justify-content-end team flex-md-row center-escudo">
            <div class="title">
                {{ event?.equipo_local?.nombre || 'N/A' }}
            </div>
            <span class="escudos">
                <img :src="event?.equipo_local?.imagen" alt="Imagen equipo local" v-if="event?.equipo_local?.imagen"/>
            </span>
        </div>
        <div class="d-md-flex d-none gradient-color vs">
            VS
        </div>
        <div class="align-content-center d-flex flex-md-nowrap flex-wrap info justify-content-center order-md-first ">
            <div class="competition order-md-last">
                <span>
                    <img :src="event?.division?.imagen" alt="Imagen division" v-if="event?.division?.imagen"/>
                </span>
            </div>
            <div class="text-md-left">
                <div v-if="!event?.varias_sesiones">
                    <div class="date">
                        {{ event?.fecha || 'Fecha no disponible' }}
                    </div>
                    <div class="time">
                        {{ event?.hora ? event.hora + 'H' : 'Hora no disponible' }}
                    </div>
                </div>
                <div v-else class="date">
                    <p class="ml-md-4 mt-md-3">Varias <br/> Sesiones</p>
                </div>
                <div class="info_fecha">
                    <small class="d-block w-100" v-if="event?.fecha_provisional">
                        {{ $t('partidos.fecha_provisional') }}
                    </small>
                    <template v-if="event?.synopsis">
                        <small class="d-block w-80 p-0">
                            <div class="button p-1 pb-2 mt-1" @click="showModal('descripcion-' + event.id)">
                                <small style="font-size: 10px">
                                    {{ $t('partidos.info') }}
                                </small>
                            </div>
                        </small>
                        <InformacionModal :evento_id="event.id" :descripcion="event.synopsis" :politica_menores="event.underage_policy" @close="closeModal"/>
                    </template>
                </div>
            </div>
        </div>
        <div class="d-flex flex-fill flex-lg-row-reverse team justify-content-lg-end flex-lg-nowrap text-lg-left center-escudo">
            <div class="title">
                {{ event?.equipo_visitante?.nombre || 'N/A' }}
            </div>
            <span class="escudos">
                <img :src="event?.equipo_visitante?.imagen" alt="Imagen equipo visitante" v-if="event?.equipo_visitante?.imagen"/>
            </span>
        </div>
        <slot></slot>
    </li>
</template>

<script>
    import EventMetadata from "@/components/metadata/EventMetadata";
    import InformacionModal from '@/views/frontend/events/layouts/index/modals/InformacionModal';

    export default {
        props: {
            event: {
                required: true,
                type: Object
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: {
            EventMetadata, InformacionModal
        }
    }
</script>

<style scoped>
    .info_fecha {
        margin-left: 13px; 
        margin-top: 3px;
        align-items: center;
        vertical-align: middle;
    }
    
    @media (max-width: 768px) {
        .info_fecha {
            margin-left: 0; 
        }
    }

    .escudos {
        width: 75px; 
        height: 75px;
        flex-shrink: 0; 
        display: flex;
        align-items: center; 
        justify-content: center;
    }

    .escudos img {
        max-width: 100%; 
        max-height: 100%; 
        width: auto;
        height: auto;
        object-fit: contain; 
    }

    .center-escudo {
            align-items: center;
            vertical-align: middle;
        }
</style>